export const newConfig = [
  {
    head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
    body: [
      {
        route: "home",
        component: "EDCRForm",
        nextStep: "",
        hideInEmployee: true,
        key: "ScrutinyDetails",
        texts: {
          headerCaption: "",
          header: "EDCR_COMMON_APPL_NEW",
          cardText: "BPA_PROVIDE_REQ_FOR_NEW_BPA",
          submitBarLabel: "EDCR_SCRUTINY_SUBMIT_BUTTON",
          skipText: "EDCR_CLEAR_FORM",
        },
      },
    ],
  }
];
